import panel_date_range_vue_vue_type_script_setup_true_lang_default from "./panel-date-range.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/panel-date-range.vue
var panel_date_range_default = panel_date_range_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_date_range_default as default };
//# sourceMappingURL=panel-date-range.mjs.map